import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, Users, Euro, Clock, TrendingUp, Shield } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getRouteByKey, isRouteAvailable, type SiteLanguage } from "@/utils/routing";

const SmallBusinessSection = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language as SiteLanguage;

  const icons = [Users, Euro, Clock, TrendingUp, Shield, CheckCircle];
  const benefitsData = t("pages.home.smallBusiness.benefits", { returnObjects: true }) as Array<{title: string; description: string}>;

  const benefits = benefitsData.map((benefit, index) => ({
    icon: icons[index],
    ...benefit
  }));

  return (
    <section className="section-padding bg-secondary/20">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-section mb-6">
            {t("pages.home.smallBusiness.title")}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {t("pages.home.smallBusiness.subtitle")}
          </p>
        </div>

        <div className="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {benefits.map((benefit, index) => {
            const IconComponent = benefit.icon;
            return (
              <Card key={index} className="glass-card hover-lift">
                <CardContent className="p-4 sm:p-6 text-center">
                  <div className="flex justify-center mb-4">
                    <IconComponent className="h-8 w-8 text-primary" />
                  </div>
                  <h3 className="text-lg sm:text-xl font-semibold mb-3 text-foreground">
                    {benefit.title}
                  </h3>
                  <p className="text-muted-foreground">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 text-center space-y-4">
          <div className="inline-flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-4 glass-card p-4 sm:p-6 rounded-lg">
            <CheckCircle className="h-6 w-6 text-green-500" />
            <span className="text-base sm:text-lg font-medium text-center sm:text-left">
              {t("pages.home.smallBusiness.trustMessage")}
            </span>
          </div>
          {isRouteAvailable("soloOffer", lang) && (
            <div>
              <Link
                to={getRouteByKey("soloOffer", lang)}
                className="inline-flex items-center text-primary font-medium hover:underline"
                data-testid="link-home-solo-offer"
              >
                {t("pages.home.smallBusiness.soloCta")}
              </Link>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SmallBusinessSection;